import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import InlineValue from '../InlineValue';

export default class ListSelectDisplay extends PureComponent {
  static propTypes = {
    toggleEditor: PropTypes.func,
    value: PropTypes.string,
    userMode: PropTypes.string,
  };

  render() {
    const { toggleEditor, userMode, value } = this.props;
    const clickToEdit = (userMode !== 'reader')
      ? <span className="clickToEdit">Click to edit</span>
      : null;
    const displayValue = (
      <InlineValue toggleEditor={toggleEditor} userMode={userMode}>
        {value || clickToEdit}
      </InlineValue>
    );
    return displayValue;
  }
}



// WEBPACK FOOTER //
// ./src/components/types/ListSelect/ListSelectDisplay.js